var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7E97",
    fillRule: "evenodd",
    d: "m11.203 9.974 4.537 4.519c.347.345.347.904 0 1.248s-.907.345-1.253 0L9.94 11.213a6.23 6.23 0 0 1-3.702 1.212C2.793 12.425 0 9.644 0 6.213 0 2.78 2.793 0 6.238 0s6.238 2.781 6.238 6.213a6.17 6.17 0 0 1-1.273 3.761m-4.965 1.143c2.72 0 4.925-2.196 4.925-4.904 0-2.71-2.205-4.905-4.925-4.905S1.313 3.504 1.313 6.213s2.205 4.904 4.925 4.904"
  })));
};
export default SvgSearch;